<template>
  <div v-if="data.media && data.media.length || data.youtubeVideoId || data.vimeoVideoId" class="media u-row u-center u-relative u-pad-y-xl u-pad-y-md--sm">
    <div class="u-relative" :class="data.mediaPosition ? 'u-w12of12' : 'u-w10of12'">
      <div :class="data.mediaPosition ? '' : 'u-radius u-overflow-hidden u-relative'">
        <app-image v-if="isImage && !data.youtubeVideoId && !data.vimeoVideoId" :width="2200" :id="data.media[0].id" :src="data.media[0].url" alt="Project picture" class="u-full-width" :class="" />
        <video-player
          v-if="!isImage && !data.youtubeVideoId && !data.vimeoVideoId"
          :src="data.media[0].url"
          :poster="data.mediaPreview.length ? data.mediaPreview[0].url : ''"
          :forcePlay="data.isMediaAutoPlay"
          :isWrapperPanel="false"
        />
        <youtube-player v-else-if="data.youtubeVideoId" :id="data.youtubeVideoId" :poster="data.mediaPreview.length ? data.mediaPreview[0].url : ''" />
        <vimeo-player v-else-if="data.vimeoVideoId" :id="data.vimeoVideoId" :poster="data.mediaPreview.length ? data.mediaPreview[0].url : ''" />
      </div>
        <div
          class="u-row u-middle"
          :class="[
            classText,
            data.isTextOver ? 'u-wrapper-panel u-pad-x-1of12 t-h3' : 'u-marg-t-md u-black t-h4',
            data.isTextOver && data.backgroundColored ? 'u-blue' : 'u-white',
          ]">
        {{ data.text }}
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'
import YoutubePlayer from '@/components/common/players/YoutubePlayer'
import VimeoPlayer from '@/components/common/players/VimeoPlayer'

export default {
  components: {
    VideoPlayer,
    YoutubePlayer,
    VimeoPlayer
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    classText () {
      return this.data.textPosition === 'left' ? 'u-left' : this.data.textPosition === 'right' ? 'u-right' : 'u-center'
    }
  },

  data() {
    let isImage = true
    if (this.data.media.length) {
      if(['mp4', 'm4v'].includes(this.data.media[0].extension.toLowerCase())) {
        isImage = false
      }
    }
    return {
      isImage: isImage
    }
  },
}
</script>